// extracted by mini-css-extract-plugin
export default {"default-warranty":"rules_default-warranty__CFVA1","ant-input":"rules_ant-input__3WbS0","ant-btn":"rules_ant-btn__LmsDb"};